import React, { useEffect, useState } from "react";
import TopBar from "../components/menu/TopBar";
import Card1 from "../components/Card/Card1";
import Messages from "./Messages";
import { useSelector, useDispatch } from "react-redux";
import { language } from "../stores/slices/languageSlice";
import EmptyApplication from "./EmptyApplication.gif";
import { Filter } from "react-feather";
import applicationsSlice, {
  applists,
  setApplicationList,
  allApplicationList,
  fetchFilterAppListsCPR,
  fetchFilterAppListsFAF,
  resetApplicationUpdateflage,
  restRenderFlage
} from "../stores/slices/applicationsSlice";
import ReactPaginate from "react-paginate";
import Input from "../components/input/Input";
import validateInput from "../utilities/validations/validateInput";
import moment from "moment";
import SvgLoader from "../components/menu/SvgLoader";
import { useNavigate } from 'react-router-dom'
import Tooltip from '../components/btooltip/Tooltip'
import { IsPatientLockedReset } from "../stores/slices/patientSearch/patientSearchSlice";
import Loader from "../components/menu/Loader";
import { toast } from "react-toastify";
import { fetchFilterFund } from "../stores/slices/filterFundSlice";

function Applications() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [itemsPerPage, setItemaPerPage] = useState(0);
  const selectedLanguage = useSelector(language).Applications;
  const applicationLists = useSelector((state) => state.applicationsSlice);
  const caseLists = useSelector((state)=>state.caseListSlice.caseList)
  const loginStatus = useSelector((state) => state.loginSlice);
  const loader = useSelector((state) => state.generateHashDataSlice.loader)
  const [appList, setAppList] = useState([]);
  const [dropDownStatus, setDropDownStatus] = useState([{ key: "", value: "" }, { key: "Approved", value: "Approved" }, { key: "Pending", value: "Pending" }, { key: "Closed", value: "Closed" }, { key: "Denied", value: "Denied" }, { key: "Expired", value: "Expired" }]);
  const [dropDownFunds, setDropDownFunds] = useState([]);
  const [searchFilterIsOpen, setSearchFilterIsOpen] = useState(false);
  const [searchFilterBtnText, setSearchFilterBtnText] = useState(false);
  const [noDocumentFlag, setNoDocumentFlag] = useState(false);
  const [activeBtn, setActiveBtn] = useState("ALL");
  const [showLoader, setShowLoader] = useState(false)
  const [sortedCaseList, setSortedCaseList] = useState([])

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [radioData, setRadioData] = useState({
    filterExpiry: {
      value: "",
      check: false,
    },
    filterActionsRequired: {
      value: "",
      check: false,
    },
    filterAppClosure: {
      value: "",
      check: false,
    },
  });
  const [programData, setProgramData] = useState(["Applications and Cases"])
  const [searchDetails, setSearchDetails] = useState({
    Patient_Name: {
      value: "",
      isValid: true,
    },
    Patient_Status: {
      value: "",
      isValid: true,
    },
    Patient_Fund: {
      value: "",
      isValid: true,
    },
    Patient_DOB: {
      value: "",
      isValid: true,
    },
    Patient_SSN: {
      value: "",
      isValid: true,
    },
    Patient_AlienNumber: {
      value: "",
      isValid: true,
    },appCreatedDateTo: {
      value: "",
      isValid: true,
    },appCreatedDateFrom: {
      value: "",
      isValid: true,
    },
  });

  let radioExpiry = [
    {
      key: "IsExpiryInWeek",
      value: "Expiring in the next 7 days",
    },
    {
      key: "IsExpiredLastWeek",
      value: "Expired in the last 7 days",
    },
    {
      key: "IsExpiredLastMonth",
      value: "Expired in the last 30 days",
    },
  ];
  let radioActionsRequired = [
    {
      key: "DiagnosisVerification",
      value: "Missing Diagnosis Verification",
    },
    { key: "IncomeProof", value: "Missing Income Document" },
    {
      key: "NoClaim",
      value: "Pending Revoke – No Claims Activity",
    },
  ];
  let radioAppClosure = [
    { key: "IsRevokedToday", value: "Revoked today" },
    { key: "IsRevokedInWeek", value: "Revoking in 7 days" },
  ];
  const radioOnClick = (e, check, index) => {
    let name = e.target.name;
    let value = e.target.value;
    setRadioData((preState) => ({
      ...preState,
      [name]: {
        value: value,
      },
    }));
  };

  const programFilter = (e) => {
      setProgramData([e.target.value])
  }

  const searchFilterBtn = (e) => {
    if (e.target.innerText === "Reset Filter") {

      setAppList(applicationLists.allApplicationList);
      if (applicationLists.allApplicationList.length >= 1) {
        setNoDocumentFlag(false)
      }
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(
        applicationLists.allApplicationList.slice(itemOffset, endOffset)
      );
      setPageCount(
        Math.ceil(applicationLists.allApplicationList.length / itemsPerPage)
      );
      setSearchDetails((preState) => ({
        ...preState,
        Patient_Name: {
          value: "",
          isValid: true,
        },
        Patient_Status: {
          value: "",
          isValid: true,
        },
        Patient_Fund: {
          value: "",
          isValid: true,
        },
        Patient_DOB: {
          value: "",
          isValid: true,
        },
        Patient_SSN: {
          value: "",
          isValid: true,
        },
        Patient_AlienNumber: {
          value: "",
          isValid: true,
        },appCreatedDateTo: {
          value: "",
          isValid: true,
        },appCreatedDateFrom: {
          value: "",
          isValid: true,
        },
      }));
      setRadioData((preState) => ({
        ...preState,
        filterExpiry: {
          value: "",
          check: false,
        },
        filterActionsRequired: {
          value: "",
          check: false,
        },
        filterAppClosure: {
          value: "",
          check: false,
        },
      }));
      setProgramData(["Applications and Cases"])
      setSearchFilterBtnText(false);
    } else {
      // setNoDocumentFlag(false);
      setSearchFilterIsOpen(!searchFilterIsOpen);
    }
  };
  const applyFilterBtn = async () => {
    let filterStatus = searchDetails.Patient_Status.value;
    let filterpatientName = searchDetails.Patient_Name.value
      .split(" ")
      .join("")
      .toLowerCase();
    let filterFunds = searchDetails.Patient_Fund.value;
    let filterSSN =
      searchDetails.Patient_SSN.value == ""
        ? searchDetails.Patient_AlienNumber.value
        : searchDetails.Patient_SSN.value;
    let filterDob = searchDetails.Patient_DOB.value;
    let filterExpry = radioData.filterExpiry.value;
    let filterAppClosure = radioData.filterAppClosure.value;
    let filterActionsRequired = radioData.filterActionsRequired.value;
    const appCreatedDateFrom = searchDetails.appCreatedDateFrom.value
    const appCreatedDateTo = searchDetails.appCreatedDateTo.value

    if ((appCreatedDateFrom && !appCreatedDateTo) || (!appCreatedDateFrom && appCreatedDateTo)) {
      toast.error("Both From Date and To Date are required.");
      return false;
    }
  
    const today = new Date();
    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(today.getFullYear() - 2);
  
    const from = new Date(appCreatedDateFrom);
    const to = new Date(appCreatedDateTo);
  
    // Future date check
    if (from > today || to > today) {
      toast.error("Future dates are not allowed.");
      return false;
    }

    function normalizeDate(date) {
      return new Date(date.toISOString().split("T")[0]);
    }
  // const todayDate = normalizeDate(new Date());
  const twoYearsAgoDate = normalizeDate(new Date(new Date().setFullYear(new Date().getFullYear() - 2)));

    if (appCreatedDateFrom && appCreatedDateTo) {
      // Last 2 years check
    if (normalizeDate(from) < twoYearsAgoDate || normalizeDate(to) < twoYearsAgoDate) {
      setSearchDetails((prev) => ({
        ...prev,
        appCreatedDateFrom: {
          value: prev.appCreatedDateFrom.value,
          isValid: from >= twoYearsAgo,
        },
        appCreatedDateTo: {
          value: prev.appCreatedDateTo.value,
          isValid: to >= twoYearsAgo,
        },
      }));
      toast.error("Dates must be within the last 2 years.");
      return false;
    }
  }
  
    // From <= To check
    if (from > to) {
      toast.error("From Date cannot be later than To Date.");
      return false;
    } 

    let formValidate =
      searchDetails.Patient_Name.value == "" &&
      searchDetails.Patient_Status.value == "" &&
      searchDetails.Patient_Fund.value == "" &&
      searchDetails.Patient_DOB.value == "" &&
      searchDetails.Patient_SSN.value == "" &&
      searchDetails.Patient_AlienNumber.value == "" &&
      searchDetails.appCreatedDateFrom.value == "" &&
      searchDetails.appCreatedDateTo.value == "" &&
      radioData.filterExpiry.value == "" &&
      radioData.filterAppClosure.value == "" &&
      radioData.filterActionsRequired.value == "" && programData.includes("Applications and Cases");
    if (formValidate) {
      setActiveBtn("ALL");
      setAppList(applicationLists.allApplicationList);
      setSearchFilterIsOpen(false);
      return
    }
    // let array=[]
    // if (activeBtn == selectedLanguage.CPR) {
    //     array = applicationLists.valueCPR;
    //   } else if (activeBtn == selectedLanguage.FAF) {
    //     array = applicationLists.valueFAF;
    //   } else {
    //     array = applicationLists.allApplicationList;
    //   } 
      // let applicationViewlist = array.filter(
      //   (data) => {
      //    let name = (data.pxPages != undefined && data.pxPages !='' && data.pxPages.Member != undefined && data.pxPages.Member !='' && data.pxPages.Member.pyFullName != undefined && data.pxPages.Member.pyFullName !='' && data.pxPages.Member.pyFullName.split(" ").join('').toLowerCase()) || (data?.PatientFullName?.split(" ").join('').toLowerCase());
		  //    let dob  = (data.pxPages != undefined && data.pxPages !='' && data.pxPages.Member != undefined && data.pxPages.Member !='' && data.pxPages.Member.DateOfBirth != undefined && data.pxPages.Member.DateOfBirth !='' && data.pxPages.Member.DateOfBirth) || data?.PatientDOB;
		  //    let SSNR  = (data.pxPages != undefined && data.pxPages !='' && data.pxPages.Member != undefined && data.pxPages.Member !='' && data.pxPages.Member.SocialSecurityNumber != undefined && data.pxPages.Member.SocialSecurityNumber !='' && data.pxPages.Member.SocialSecurityNumber) || data?.PatientSSN;
		  //    let Alin  = (data.pxPages != undefined && data.pxPages !='' && data.pxPages.Member != undefined && data.pxPages.Member !='' && data.pxPages.Member.AlienNumber != undefined && data.pxPages.Member.AlienNumber !='' && data.pxPages.Member.AlienNumber) || data?.PatientAlienNumber;
         
      //     if (
      //       ((filterExpry == "IsExpiryInWeek" && data.IsExpiryInWeek == "true") ||
      //         (filterExpry == "IsExpiredLastWeek" &&
      //           data.IsExpiredLastWeek == "true") ||
      //         (filterExpry == "IsExpiredLastMonth" &&
      //           data.IsExpiredLastMonth == "true") ||
      //         filterExpry == "") &&
      //       ((filterAppClosure == "IsRevokedToday" &&
      //         data.IsRevokedToday == "true") ||
      //         (filterAppClosure == "IsRevokedInWeek" &&
      //           data.IsRevokedInWeek == "true") ||
      //         filterAppClosure == "") &&
      //       ((filterActionsRequired == "IncomeProof" &&
      //         data.IncomeProof == "true") ||
      //         (filterActionsRequired == "NoClaim" && data.NoClaim == "true") ||
      //         (filterActionsRequired == "DiagnosisVerification" &&
      //           data.DiagnosisVerification == "true") ||
      //         filterActionsRequired == "") &&
      //       ((filterStatus != "" &&
      //         (filterStatus == "Active"
      //           ? data.PortalAppStatus == "Approved" ||
      //             data.PortalAppStatus == "Pending"
      //           : data.PortalAppStatus == filterStatus)) ||
      //         filterStatus == "") &&
      //       ((filterFunds != "" && data.FundName == filterFunds) ||
      //         filterFunds == "") &&
      //       ((filterpatientName != "" && typeof name === "string" && name.startsWith(filterpatientName)) ||
      //         filterpatientName == "") &&
      //       ((filterSSN != "" && SSNR == filterSSN) ||
      //         (filterSSN != "" && Alin == filterSSN) ||
      //         filterSSN == "") &&
      //       ((filterDob != "" &&
      //         (moment(dob).format("YYYYMMDD") ==
      //           moment(filterDob).format("YYYYMMDD"))) ||
      //         filterDob == "")
      //     ) {
      //       if(programData.length > 0 ){
      //       const program = data.program == "CASE" ? "Cases" : "Applications"
      //       if (programData.includes("Applications and Cases") || programData.includes(program)) {
      //           return data
      //       }
      //     }else{
      //       return false
      //     }
      //     }
      //   }
      // );
      let applicationViewlist = []
      const expiryDays = filterExpry == "IsExpiryInWeek" ? "7" : filterExpry == "IsExpiredLastWeek" ? "-7" : filterExpry == "IsExpiredLastMonth" ? "-30" : ""
      const RevokeDays = filterAppClosure == "IsRevokedInWeek" ? "-7" : filterAppClosure == "IsRevokedToday" ? "0" : ""
      const MissingDiagnosisVerification = filterActionsRequired == "DiagnosisVerification" ? true : false
      const MissingIncomeDocument = filterActionsRequired == "IncomeProof" ? true : false
      const NoClaimActivity = filterActionsRequired == "NoClaim" ? true : false
      const DOB = moment(filterDob).format('YYYYMMDD') != "Invalid date" ? moment(filterDob).format('YYYYMMDD') : ""
      const startDate = moment(appCreatedDateFrom).format('YYYYMMDD') != "Invalid date" ? moment(appCreatedDateFrom).format('YYYYMMDD') : ""
      const endDate = moment(appCreatedDateTo).format('YYYYMMDD') != "Invalid date" ? moment(appCreatedDateTo).format('YYYYMMDD') : ""
      const paramData = `ExpireDays=${expiryDays}&RevokeDays=${RevokeDays}&MissingDiagnosisVerification=${MissingDiagnosisVerification}&MissingIncomeDocument=${MissingIncomeDocument}&NoClaimActivity=${NoClaimActivity}&PatientName=${searchDetails.Patient_Name.value}&PatientSSNNumber=${searchDetails.Patient_SSN.value}&PatientAlienNumber=${searchDetails.Patient_AlienNumber.value}&AppStatus=${filterStatus}&FundID=${filterFunds}&PatientDOB=${DOB}&AppCreatedDateFrom=${startDate}&AppCreatedDateTo=${endDate}`

      if(programData.includes("Applications and Cases") || programData.includes("Applications")){
      const applicationMapping = (applications) =>{
        applications.payload.res.length > 0 &&
        applications.payload.res.map((data) => {
              var year = data?.PatientDOB.substring(0, 4);
              var month = data?.PatientDOB.substring(4, 6);
              var day = data?.PatientDOB.substring(6, 8);
  
              // Format the date as mm/dd/yyyy
              var formattedDate = month + '/' + day + '/' + year;
              let value = {
                program: applications.payload.prg,
                ApplicationID: data?.ApplicationID || "--",
                PatientFullName: data?.pxPages?.Member?.pyFullName || data?.PatientFullName || "--",
                PortalAppStatus: data?.PortalAppStatus || "--",
                PatientBalance: data?.PatientBalance || "--",
                awardAmount: data?.AwardAmount == "0" ? "$0.00" : `$${Number(data?.AwardAmount).toFixed(2)}`,
                patientBalance: data?.PatientBalance ? (data?.PatientBalance == "0" ? "$0.00" : `$${Number(data?.PatientBalance).toFixed(2)}`) : "--",
                unGuaranteedAmount: data?.UnGuaranteedAmount == "0" ? "$0.00" : `$${Number(data?.UnGuaranteedAmount).toFixed(2)}`,
                guaranteedAmount: data?.GuaranteedAmount == "0" ? "$0.00" : `$${Number(data?.GuaranteedAmount).toFixed(2)}`,
                FundName: data?.FundName || "--",
                AwardYear: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? data?.AppApprovalDateTime.substring(0, 4) : '--',
                AppLookBackDate: typeof data?.AppLookBackDate != 'undefined' && data?.AppLookBackDate != '' ?  moment(data?.AppLookBackDate).tz('America/New_York').format('ll') : "--",
                AppApprovalDateTime: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? moment(data?.AppApprovalDateTime).tz('America/New_York').format('ll') : "--",
                AppExpirationDate: typeof data?.AppExpirationDate != 'undefined' && data?.AppExpirationDate != "" ? moment(data?.AppExpirationDate).tz('America/New_York').format('ll') : "--",
                appGracePeriod: typeof data?.AppGracePeriod != 'undefined' && data?.AppGracePeriod != "" ? moment(data?.AppGracePeriod).tz('America/New_York').format('ll') : "--",
                revokeDate: typeof data?.AppResolvedDateTime != 'undefined' && data?.AppResolvedDateTime != "" ? moment(data?.AppResolvedDateTime).tz('America/New_York').format('ll') : "--",
                pxCreateDateTime: data?.pxCreateDateTime || "",
                IncomeProof: data?.IncomeProof,
                AppStatusReason: data?.AppStatusReason,
                FundGroup: data?.FundGroup,
                FundID: data?.FundID,
                DiagnosisVerification: data?.DiagnosisVerification,
                IsEligibleForClaim: data?.IsEligibleForClaim,
                IsEligibleForDoc: data?.IsEligibleForDoc,
                IsEligibleForReapply: data?.IsEligibleForReapply,
                IsExpiredLastMonth: data?.IsExpiredLastMonth,
                IsExpiredLastWeek: data?.IsExpiredLastWeek,
                IsExpiryInWeek: data?.IsExpiryInWeek,
                IsLookBackAvailable: data?.IsLookBackAvailable,
                IsPDMICardGenerated: data?.IsPDMICardGenerated,
                IsPEXAvailable: data?.IsPEXAvailable,
                IsPEXEnrolled: data?.IsPEXEnrolled,
                IsRenewal: data?.IsRenewal,
                IsRevokedInWeek: data?.IsRevokedInWeek,
                IsRevokedToday: data?.IsRevokedToday,
                IVAuditFlag: data?.IVAuditFlag,
                NoClaim: data?.NoClaim,
                PatientBalance: data?.PatientBalance,
                PatientDOB: formattedDate,
                PatientID: data?.PatientID,
                PatientSSN: data?.PatientSSN,
                PatientAlienNumber: data?.PatientAlienNumber,
                ProgramID: data?.ProgramID,
                pxCreateDateTime: data?.pxCreateDateTime,
                DisplayName: data?.DisplayName
              };
              applicationViewlist.push(value);
            });
      }
    
      setShowLoader(true)
      setSearchFilterIsOpen(false)
      const cprAppList = await dispatch(fetchFilterAppListsCPR({ Program: "CPR", EIN: loginStatus.value.EIN, paramData }));
      applicationMapping(cprAppList)
      const fafAppList = await dispatch(fetchFilterAppListsFAF({ Program: "FAF", EIN: loginStatus.value.EIN, paramData }));
      applicationMapping(fafAppList)  
    }
    if(programData.includes("Applications and Cases") || programData.includes("Cases")){
      if(filterpatientName != "" || filterStatus != "" || filterSSN != "" || (startDate != "" && endDate != "") || filterDob != "" ){ 
      sortedCaseList.map(
        (data) => {
         let name = data?.PatientFullName?.split(" ").join('').toLowerCase();
		     let dob  =  data?.PatientDOB;
		     let createdDate  = data.createddate != undefined && data.createddate !='' && data.createddate;
		     let SSNR  =  data?.PatientSSN;
		     let Alin  =  data?.PatientAlienNumber;

          if (
              (filterStatus != "" && data.PortalAppStatus == filterStatus) ||
            (filterpatientName != "" && typeof name === "string" && name.startsWith(filterpatientName)) ||
            ((filterSSN != "" && SSNR == filterSSN) ||
              (filterSSN != "" && Alin == filterSSN)) &&
            (!startDate || moment(createdDate).isSameOrAfter(moment(startDate), "day")) &&
            (!endDate   || moment(createdDate).isSameOrBefore(moment(endDate), "day")) ||
            ((filterDob != "" &&
              (moment(dob).format("YYYYMMDD") ==
                moment(filterDob).format("YYYYMMDD"))))
          ) {
                applicationViewlist.push(data)
                return data
          }
        }
      );
    }else if(filterpatientName == "" && filterStatus == "" && filterSSN == "" && (startDate == "" && endDate == "") && filterDob == "" && expiryDays == "" && RevokeDays == "" && MissingDiagnosisVerification == false && MissingIncomeDocument == false && NoClaimActivity == false && filterFunds == ""){
      applicationViewlist = [...applicationViewlist, ...sortedCaseList]
    }
  }
    setAppList(applicationViewlist);
    setShowLoader(false)

    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(applicationViewlist.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(applicationViewlist.length / itemsPerPage));
    if (applicationViewlist.length == 0) {
      setNoDocumentFlag(true);
    } else {
      setNoDocumentFlag(false);
    }
    setSearchFilterIsOpen(false);
    setSearchFilterBtnText(true);
    // const newOffset = (0* itemsPerPage) % appList.length;
    setItemOffset(0);
  };
  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(appList.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(appList.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % appList.length;
    setItemOffset(newOffset);
  };

  const inputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);

    setSearchDetails((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };

  // useEffect(() => {
   
  //   if(applicationLists.applicationUpdateflage){
  //     dispatch(restRenderFlage())
  //     dispatch(fetchAppListsCPR({Program:'CPR', EIN:loginStatus.value.EIN}))
  //     dispatch(fetchAppListsFAF({Program:'FAF', EIN:loginStatus.value.EIN}))
  //   }
     
  // },[applicationLists.applicationUpdateflage]);
  useEffect(() => {
    let sortList = [];
    let listCPR = JSON.stringify(applicationLists.valueCPR);
    // let listCPR = JSON.stringify(applistsConstent);
    listCPR = JSON.parse(listCPR);
    let listFAF = JSON.stringify(applicationLists.valueFAF);
    listFAF = JSON.parse(listFAF);
    sortList = listCPR.concat(listFAF);
    if (caseLists[0]?.program != "" && caseLists[0]?.program != "--") {
      let listCASE = JSON.stringify(caseLists);
      listCASE = JSON.parse(listCASE);
      setSortedCaseList(listCASE)
      sortList = sortList.concat(listCASE)
    }
    let sortArray = sortList.sort((b, a) => moment(a?.pxCreateDateTime, 'YYYY-MM-DDThh:mm:ssZ').unix() - moment(b?.pxCreateDateTime, 'YYYY-MM-DDThh:mm:ssZ').unix());
    setAppList(sortArray);
    dispatch(allApplicationList(sortArray));
    setItemaPerPage(4);
    dispatch(resetApplicationUpdateflage(false))
  }, [])

  const filterFundLists = async()=>{
    const cprFund = await dispatch(fetchFilterFund({ Program: "CPR", EIN: loginStatus.value.EIN  }))
    const fafFund = await dispatch(fetchFilterFund({ Program: "FAF", EIN: loginStatus.value.EIN  }))
    let FundDropdown = [];
    cprFund?.payload?.res?.length > 0 && cprFund?.payload?.res?.map((data) => {
      let FundNameList = { key: data.FundID, value: data.DisplayName };
      FundDropdown.push(FundNameList);
    });
    fafFund?.payload?.res?.length > 0 && fafFund?.payload?.res?.map((data) => {
      let FundNameList = { key: data.FundID, value: data.DisplayName };
      FundDropdown.push(FundNameList);
    });
    const Fund_object = new Set();
    const filteredDuplicatedFunds = FundDropdown.filter((el) => {
      const duplicate = Fund_object.has(el.key);
      Fund_object.add(el.key);
      return !duplicate;
    });
    setDropDownFunds(filteredDuplicatedFunds);
  } 

  useEffect(() => {
    filterFundLists()
    // let FundDropdown = [{ key: "", value: " " }];
    // let StatusDropdown = [{ key: "", value: " " }];
    // applicationLists.allApplicationList.map((data) => {
    //   if (
    //     data.PortalAppStatus == "Pending" ||
    //     data.PortalAppStatus == "Approved"
    //   ) {
    //     let pyStatusWorkList = {
    //       key: "Active",
    //       value: "Active",
    //     };
    //     StatusDropdown.push(pyStatusWorkList);
    //   }
    //   let pyStatusWorkList = {
    //     key: data.PortalAppStatus,
    //     value: data.PortalAppStatus,
    //   };
    //   StatusDropdown.push(pyStatusWorkList);
    //   let FundNameList = { key: data.FundName, value: data.FundName };
    //   FundDropdown.push(FundNameList);
    // });
    // const Status_object = new Set();
    // const filteredDuplicatedStatus = StatusDropdown.filter((el) => {
    //   const duplicate = Status_object.has(el.key);
    //   Status_object.add(el.key);
    //   return !duplicate;
    // });
    // const Fund_object = new Set();
    // const filteredDuplicatedFunds = FundDropdown.filter((el) => {
    //   const duplicate = Fund_object.has(el.key);
    //   Fund_object.add(el.key);
    //   return !duplicate;
    // });
    // setDropDownFunds(filteredDuplicatedFunds);
    // setDropDownStatus(filteredDuplicatedStatus);
  }, [applicationLists.allApplicationList]);

  const filterOptionBtn = (e) => {
    let array = [];
    setSearchFilterBtnText(false)
    setSearchDetails((preState) => ({
      ...preState,
      Patient_Name: {
        value: "",
        isValid: true,
      },
      Patient_Status: {
        value: "",
        isValid: true,
      },
      Patient_Fund: {
        value: "",
        isValid: true,
      },
      Patient_DOB: {
        value: "",
        isValid: true,
      },
      Patient_SSN: {
        value: "",
        isValid: true,
      },
      Patient_AlienNumber: {
        value: "",
        isValid: true,
      },appCreatedDateTo: {
        value: "",
        isValid: true,
      },appCreatedDateFrom: {
        value: "",
        isValid: true,
      },
    }));
    setRadioData((preState) => ({
      ...preState,
      filterExpiry: {
        value: "",
        check: false,
      },
      filterActionsRequired: {
        value: "",
        check: false,
      },
      filterAppClosure: {
        value: "",
        check: false,
      },
    }));
    setProgramData(["Applications and Cases"])
    setSearchFilterIsOpen(false);
    let activeBtnText = e.target.innerText;
    setActiveBtn(activeBtnText);
    if (activeBtnText == selectedLanguage.CPR) {
      array = applicationLists.valueCPR;
    } else if (activeBtnText == selectedLanguage.FAF) {
      array = applicationLists.valueFAF;
    } else {
      array = applicationLists.allApplicationList;
    }
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(array.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(array.length / itemsPerPage));
    if (array.length == 0) {
      setNoDocumentFlag(true);
    } else {
      setNoDocumentFlag(false);
    }
    let FundDropdown = [{ key: "", value: " " }];
    let StatusDropdown = [{ key: "", value: " " }];
    setAppList(array);
    array.map((data) => {
      if (
        data.PortalAppStatus == "Pending" ||
        data.PortalAppStatus == "Approved"
      ) {
        let pyStatusWorkList = {
          key: "Active",
          value: "Active",
        };
        StatusDropdown.push(pyStatusWorkList);
      }
      let pyStatusWorkList = {
        key: data.PortalAppStatus,
        value: data.PortalAppStatus,
      };
      StatusDropdown.push(pyStatusWorkList);
      let FundNameList = { key: data.FundName, value: data.FundName };
      FundDropdown.push(FundNameList);
    });
    const Status_object = new Set();
    const filteredDuplicatedStatus = StatusDropdown.filter((el) => {
      const duplicate = Status_object.has(el.key);
      Status_object.add(el.key);
      return !duplicate;
    });
    const Fund_object = new Set();
    const filteredDuplicatedFunds = FundDropdown.filter((el) => {
      const duplicate = Fund_object.has(el.key);
      Fund_object.add(el.key);
      return !duplicate;
    });
    setDropDownFunds(filteredDuplicatedFunds);
    setDropDownStatus(filteredDuplicatedStatus);
  };
  return (
    <div className="content">
       {loader ? <Loader /> : null}
      <TopBar />
      <div className="grid columns-12 gap-6">
        <div className="g-col-12  ">
          <div className="intro-y d-flex flex-column flex-sm-row align-items-center mt-8">
            <h2 className="fs-lg fw-medium me-auto" data-testid="appHeading">
              {selectedLanguage.heading}
            </h2>
            <div style={{ display: "none" }} className="intro-y p-2">
              <ul
                className="nav nav-pills  bg-gray-200 dark-bg-dark-1 rounded-2 mx-auto"
                role="tablist"
              >
                <li
                  id="active-users-tab"
                  className="nav-item flex-1"
                  role="presentation"
                >
                  <button
                    className={`nav-link w-full py-1.5 px-2 ${activeBtn == "ALL" ? "active" : ""
                      }`}
                    data-bs-toggle="pill"
                    data-bs-target="#active-users"
                    type="button"
                    role="tab"
                    aria-controls="active-users"
                    aria-selected="true"
                    onClick={filterOptionBtn}
                  >
                    {selectedLanguage.ALL}
                  </button>
                </li>
                <li
                  id="active-users-tab"
                  className="nav-item flex-1"
                  role="presentation"
                >
                  <button
                    className={`nav-link w-full py-1.5 px-2 ${activeBtn == "CPR" ? "active" : ""
                      }`}
                    data-bs-toggle="pill"
                    data-bs-target="#active-users"
                    type="button"
                    role="tab"
                    aria-controls="active-users"
                    aria-selected="false"
                    onClick={filterOptionBtn}
                  >
                    {selectedLanguage.CPR}
                  </button>
                </li>
                <li
                  id="inactive-users-tab"
                  className="nav-item flex-1"
                  role="presentation"
                >
                  <button
                    className={`nav-link w-full py-1.5 px-2 ${activeBtn == "FAF" ? "active" : ""
                      }`}
                    data-bs-toggle="pill"
                    data-bs-target="#active-users"
                    type="button"
                    role="tab"
                    aria-controls="report-donut-chart"
                    aria-selected="false"
                    onClick={filterOptionBtn}
                  >
                    {selectedLanguage.FAF}
                  </button>
                </li>
              </ul>
            </div>
            <button
              className="btn btn-yellow fs-base"
              onClick={searchFilterBtn}
            >
              <Filter />
              {searchFilterBtnText ? "Reset Filter" : "Search and Filter"}
            </button>
            <button
              className="btn btn-yellow fs-base m-20"
              onClick={() => {
                dispatch(IsPatientLockedReset(false))
                navigate('/createApp')
              }
              }
            >
              Create Application/Case
            </button>
          </div>
          <div className="intro-y tab-content mt-5">
            <div
              className="tab-pane fade show active"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              {searchFilterIsOpen && (
                <div className=" pb-5 Filter_container">
                  <div className="row pt-5 d-flex text-center justify-content-evenly">
                    <div className="col-12 col-md-3 col-xl-3">
                      <Input
                        type="text"
                        id="Patient_Name"
                        label={selectedLanguage.SEARCH_PATIENT_NAME}
                        name="Patient_Name"
                        value={searchDetails.Patient_Name.value}
                        isValid={searchDetails.Patient_Name.isValid}
                        onChange={(e) => inputOnChange(e, "name")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                    <div className="text-center col-md-1 col-xl-1 fs-sm-lg pt-6">{`(or)`}</div>
                    <div className="col-12 col-md-3 col-xl-3">
                      <Input
                        type="select"
                        id="Patient_Status"
                        label={selectedLanguage.SEARCH_BY_STATUS}
                        name="Patient_Status"
                        value={searchDetails.Patient_Status.value}
                        isValid={searchDetails.Patient_Status.isValid}
                        onChange={(e) => inputOnChange(e, "state")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                        elmentconfig={dropDownStatus}
                      />
                    </div>
                    <div className="text-center col-md-1 col-xl-1 fs-sm-lg pt-6">{`(or)`}</div>
                    <div className="col-12 col-md-3 col-xl-3">
                      <Input
                        type="select"
                        id="Patient_Fund"
                        label={selectedLanguage.SEARCH_BY_FUND}
                        name="Patient_Fund"
                        value={searchDetails.Patient_Fund.value}
                        isValid={searchDetails.Patient_Fund.isValid}
                        onChange={(e) => inputOnChange(e, "state")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                        elmentconfig={dropDownFunds}
                      />
                    </div>
                  </div>
                  <div className="row pb-8 pt-5 d-flex text-center justify-content-evenly">
                    <div className="col-12 col-md-3 col-xl-3">
                      <Input
                        type="date"
                        id="Patient_DOB"
                        label={selectedLanguage.SEARCH_BY_DOB}
                        name="Patient_DOB"
                        value={searchDetails.Patient_DOB.value}
                        isValid={searchDetails.Patient_DOB.isValid}
                        onChange={(e) => inputOnChange(e, "state")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                    <div className="text-center col-md-1 col-xl-1 fs-sm-lg pt-6">{`(or)`}</div>
                    <div className="col-12 col-md-3 col-xl-3 ">
                      <Input
                        type="text"
                        id="Patient_SSN"
                        label={selectedLanguage.SEARCH_BY_SSN}
                        name="Patient_SSN"
                        value={searchDetails.Patient_SSN.value}
                        isValid={searchDetails.Patient_SSN.isValid}
                        onChange={(e) => inputOnChange(e, "ssn")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                    <div className="text-center col-md-1 col-xl-1 fs-sm-lg pt-6">{`(or)`}</div>
                    <div className="col-12 col-md-3 col-xl-3 ">
                      <Input
                        content={'To enter an Alien number, type "A" and then the number: Ex Annnnnnnn'}
                        type="text_tooltip"
                        id="Patient_AlienNumber"
                        label={selectedLanguage.SEARCH_BY_ALIEN}
                        name="Patient_AlienNumber"
                        value={searchDetails.Patient_AlienNumber.value}
                        isValid={searchDetails.Patient_AlienNumber.isValid}
                        onChange={(e) => inputOnChange(e, "alienNumber")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                  </div>
                  {/* <div className="row pb-8 pt-5 d-flex text-center justify-content-evenly">
                    <div className="col-12 col-md-3 col-xl-5">
                      <Input
                        type="filterDate"
                        id="appCreatedDateFrom"
                        label={"Application Created Date From"}
                        name="appCreatedDateFrom"
                        value={searchDetails.appCreatedDateFrom.value}
                        isValid={searchDetails.appCreatedDateFrom.isValid}
                        onChange={(e) => inputOnChange(e, "dob")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                    <div className="text-center col-md-1 col-xl-1 fs-sm-lg pt-6">{`(AND)`}</div>
                    <div className="col-12 col-md-3 col-xl-5">
                      <Input
                        type="filterDate"
                        id="appCreatedDateTo"
                        label={"Application Created Date To"}
                        name="appCreatedDateTo"
                        value={searchDetails.appCreatedDateTo.value}
                        isValid={searchDetails.appCreatedDateTo.isValid}
                        onChange={(e) => inputOnChange(e, "dob")}
                        errorMsg={selectedLanguage?.inputErrorMessage}
                      />
                    </div>
                  </div> */}
                  <div className="p-5 d-flex justify-content-center">
                    <div className="row d-flex container text-center justify-content-around">
                      <div className="col-md-4 g-col-12 g-col-xl-4">
                        <p className="fs-sm-lg">{selectedLanguage.Expiry}</p>
                        {radioExpiry.map((x, index) => {
                          return (
                            <Input
                              type="radio"
                              id={x.value + index}
                              label={x.value}
                              name="filterExpiry"
                              checked={
                                radioData.filterExpiry.value == x.key
                                  ? true
                                  : false
                              }
                              value={x.key}
                              onClick={(e) => radioOnClick(e, index, x.key)}
                            />
                          );
                        })}
                      </div>
                      <div className="col-md-4 g-col-12 g-col-xl-4">
                        <p className="fs-sm-lg">
                          {selectedLanguage.Actions_Required}
                        </p>
                        {radioActionsRequired.map((x, index) => {
                          return (
                            <>{
                              x.value == "Pending Revoke – No Claims Activity" ?
                                < Tooltip content={"Apps revoking within 60 days after approval or the last claim, due to no claims activity"}>
                                  <Input
                                    type="radio"
                                    id={x.value + index}
                                    label={x.value}
                                    checked={
                                      radioData.filterActionsRequired.value == x.key
                                        ? true
                                        : false
                                    }
                                    name="filterActionsRequired"
                                    value={x.key}
                                    onClick={(e) => radioOnClick(e, index, x.key)}
                                  />
                                </Tooltip>
                                :
                                <Input
                                  type="radio"
                                  id={x.value + index}
                                  label={x.value}
                                  checked={
                                    radioData.filterActionsRequired.value == x.key
                                      ? true
                                      : false
                                  }
                                  name="filterActionsRequired"
                                  value={x.key}
                                  onClick={(e) => radioOnClick(e, index, x.key)}
                                />
                            }
                            </>
                          );
                        })}
                      </div>
                      <div className="col-md-4 g-col-12 g-col-xl-4">
                        <p className="fs-sm-lg">
                          {selectedLanguage.App_Closure}
                        </p>
                        {radioAppClosure.map((x, index) => {
                          return (
                            <Input
                              type="radio"
                              id={x.value + index}
                              label={x.value}
                              name="filterAppClosure"
                              checked={
                                radioData.filterAppClosure.value == x.key
                                  ? true
                                  : false
                              }
                              value={x.key}
                              onClick={(e) => radioOnClick(e, index, x.key)}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="p-5 d-flex justify-content-center">
                    <div className="row d-flex container text-center justify-content-around">
                      <div className="col-md-12 g-col-12 g-col-xl-4">
                        <p className="fs-sm-lg">
                          Type
                        </p>
                        {/* <div className="d-flex justify-content-evenly align-items-center ">
                        <Input
                              type="checkboxNFRD"
                              id={"Applications and Cases"}
                              label={"Applications and Cases"}
                              checked={programData.includes("Applications and Cases")}
                              name="Applications and Cases"
                              value={"Applications and Cases"}
                              onClick={(e) => programFilter(e)}
                            />
                            <Input
                              type="checkboxNFRD"
                              id={"Applications"}
                              label={"Applications"}
                              checked={programData.includes("Applications")}
                              name="Applications"
                              value={"Applications"}
                              onClick={(e) => programFilter(e)}
                            />
                             <Input
                              type="checkboxNFRD"
                              id={"Cases"}
                              label={"Cases"}
                              checked={programData.includes("Cases")}
                              name="Cases"
                              value={"Cases"}
                              onClick={(e) => programFilter(e)}
                            />
                        </div> */}
                        <div class="d-flex flex-coloumn flex-sm-row mt-5 px-5 justify-content-evenly align-items-center">
                        <div class="form-check me-2">
                            <input id="radio-switch-4" class="form-check-input" type="radio" value="Applications and Cases" name="Applications and Cases" checked={programData.includes("Applications and Cases")} onChange={(e) => programFilter(e)} />
                            <label class="form-check-label" for="radio-switch-4" >Applications and Cases</label>
                        </div>
                        <div class="form-check px-5 mt-2 mt-sm-0">
                            <input id="radio-switch-5" class="form-check-input" type="radio" name="Applications" value="Applications" checked={programData.includes("Applications")} onChange={(e) => programFilter(e)} />
                            <label class="form-check-label" for="radio-switch-5">Applications</label>
                        </div>
                        <div class="form-check px-5 mt-2 mt-sm-0">
                            <input id="radio-switch-5" class="form-check-input" type="radio" name="Cases" value="Cases" checked={programData.includes("Cases")} onChange={(e) => programFilter(e)} />
                            <label class="form-check-label" for="radio-switch-5">Cases</label>
                        </div>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-5">
                    <button
                      className="btn btn-yellow fs-base"
                      onClick={applyFilterBtn}
                    >
                      <p class="px-3">{selectedLanguage.Apply_Filter}</p>
                    </button>
                  </div>
                </div>
              )}
              {(applicationLists.loader || showLoader) ? (
                <>
                  <div className="text-center justify-content-around">
                    <SvgLoader isLoader={true} />
                  </div>
                </>
              ) : (
                <>
                  {noDocumentFlag ? (
                    <>
                      <div className="pt-6 mt-6">&nbsp; &nbsp; &nbsp;</div>
                      <div className="d-flex justify-content-center pt-8 mt-8 pb-8 mb-8">
                        <img
                          src={EmptyApplication}
                          class="img-fluid"
                          alt="EmptyApplication"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="grid columns-12 gap-10">
                        {currentItems.map((data, index) => {
                          return (
                            <div
                              className="intro-y g-col-12 g-col-lg-6"
                              key={index + 1}
                            >
                              <Card1 appData={{ applications: data }} />
                            </div>
                          );
                        })}

                        {/* <!-- BEGIN: Latest Uploads --> */}
                      </div>
                      <div className="text-center  pt-6">
                        <ReactPaginate
                          nextLabel=">"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={2}
                          pageCount={pageCount}
                          previousLabel="<"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                          renderOnZeroPageCount={null}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Applications;
